import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../lib/api';

export const SearchSuggestions = ({ query, visible, onPick }) => {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const timer = useRef(null);

  useEffect(() => {
    if (!visible || !query || query.trim().length < 2) {
      setItems([]);
      return;
    }
    clearTimeout(timer.current);
    timer.current = setTimeout(() => {
      api.get('/products/suggest', { params: { q: query.trim() } })
        .then((res) => setItems(res.data.suggestions || []))
        .catch(() => setItems([]));
    }, 200);
    return () => clearTimeout(timer.current);
  }, [query, visible]);

  if (!visible || items.length === 0) return null;

  return (
    <div
      className="absolute top-full left-0 right-0 mt-1 bg-white border border-amber-200 rounded-xl shadow-2xl z-50 overflow-hidden"
      data-testid="search-suggestions"
    >
      {items.map((p) => (
        <button
          key={p.id}
          type="button"
          onMouseDown={(e) => {
            e.preventDefault();
            onPick();
            navigate(`/products/${p.id}`);
          }}
          className="w-full flex items-center gap-3 px-3 py-2 hover:bg-amber-50 text-left"
          data-testid={`search-suggestion-${p.id}`}
        >
          {p.images?.[0] && (
            <img src={p.images[0]} alt="" className="h-9 w-9 rounded object-cover flex-shrink-0" loading="lazy" />
          )}
          <span className="flex-1 min-w-0">
            <span className="block text-sm text-slate-900 truncate">{p.name}</span>
            <span className="block text-xs text-slate-400">{p.category}</span>
          </span>
          <span className="text-sm font-semibold text-slate-900">${p.price}</span>
        </button>
      ))}
    </div>
  );
};
